import { Component, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { CmsDataMap, CmsDataMarker, CmsDataProject } from 'src/app/models/cmsdata';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy {

  @Input()
  public panEnabled: boolean = false;

  public map: CmsDataMap;
  public bgUrl: string = "unset";
  public projects: CmsDataProject[];
  public previewProject: CmsDataProject;
  public previewExpanded: boolean = false;
  public buttonExpanded: boolean = true;

  // Map positioning and size 
  public mapSize: any = {
    top: -135,
    left: -113,
    width: 641,
    height: 1389
  }
  public mapSizeCss: any = this.mapSizeCssBuild();

  // Move/pan the map
  public mousemoveSub: Subscription;
  public touchmoveSub: Subscription;
  public moving: boolean = false;
  public moveX: number = -1;
  public moveY: number = -1;
  public translateX: number = -40;
  public translateY: number = 10;
  public scale: number = 1;
  public translateCss: string = 'translate(0px, -40px) scale(1)';
  //public translateCss: string = 'translate(0px, -40px)';

  constructor(
    private dataService: DataService,
    private router: Router
  ) {
    this.subscribe();
  }

  ngOnInit(): void {
    this.mousemoveSub = fromEvent(document, "mousemove").subscribe(($event) => { this.interactMove($event); });
    this.touchmoveSub = fromEvent(document, "touchmove").subscribe(($event) => { this.interactMove($event); });
    this.fitScreen();
  }

  ngOnDestroy(): void {
    
  }

  subscribe() {
    this.dataService.map.subscribe((data) => {
      this.map = data;
      if (this.map.map_image) {
        this.bgUrl = `url('${this.map.map_image}')`;
      } else {
        this.bgUrl = "unset";
      }
    });
    this.dataService.projects.subscribe((projects: CmsDataProject[]) => {
      this.projects = projects;
    });
  }

  public mapSizeCssBuild(): any {
    return {
      top: this.stylePos(this.mapSize.top),
      left: this.stylePos(this.mapSize.left),
      width: this.stylePos(this.mapSize.width),
      height: this.stylePos(this.mapSize.height),
    };
  }

  public stylePos(pos: number|string) {
    if (pos === 0) {
      return '0px';
    } else {
      return `${pos}px`;
    }
  }

  public clickMarker($event: any, marker: CmsDataMarker) {
    if ($event) {
      $event.preventDefault();
    }
    // Don't process click when disabled
    if (!marker.enabled) {
      return;
    }
    let previewSlug = "";
    // Determine active marker
    this.map?.markers.forEach((m) => {
      if (m === marker) {
        m.active = !m.active;
      } else {
        m.active = false;
      }
      if (m.active) {
        previewSlug = m.augment_2022_marker_project;
      }
    });
    // Determine project to preview
    // - No project? Keep the previewProject data, but collapse the slide-up
    if (previewSlug) {
      const proj = this.projects.find(proj => proj.project_slug === previewSlug);
      if (proj) {
        this.previewExpanded = true;
        this.previewProject = proj;
      } else {
        this.previewExpanded = false;
      }
    } else {
      this.previewExpanded = false;
    }
    // Preview or directions button
    this.buttonExpanded = !this.previewExpanded;
  }

  public clickClose($event: any) {
    if ($event) {
      $event.preventDefault();
    }
    this.previewExpanded = false;
    this.buttonExpanded = true;
    if (this.previewProject && this.map?.markers) {
      this.map.markers.forEach((m) => {
        if (m.augment_2022_marker_project === this.previewProject.project_slug) {
          m.active = false;
        }
      });
    }
  }

  public clickDirections($event: any) {
    if ($event) {
      $event.preventDefault();
    }
    this.router.navigate(["/map/directions"]);
    // if (this.map?.directions_url) {
    //   window.open(this.map.directions_url, "_blank");
    // }
  }

  public interactDown($event: MouseEvent) {
    if (this.panEnabled) {
      this.moveX = $event.pageX;
      this.moveY = $event.pageY;
      this.moving = true;
    }
  }

  public interactUp($event: MouseEvent) {
    if (this.panEnabled) {
      this.moving = false;
    }
  }

  public interactMove($event: any) {
    if (this.panEnabled) {
      if (this.moving) {
        const diffX = $event.pageX - this.moveX;
        const diffY = $event.pageY - this.moveY;
        this.moveX = $event.pageX;
        this.moveY = $event.pageY;
        // this.translateX = Math.max(-101, Math.min(113, this.translateX + diffX));
        // this.translateY = Math.max(-35, Math.min(135, this.translateY + diffY));
        this.translateX += diffX;
        this.translateY += diffY;
        this.translateCss = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
        //this.translateCss = `translate(${this.translateX}px, ${this.translateY}px)`;
      }
    }
  }

  public interactLeave($event: any) {
    if (this.panEnabled) {
      this.moving = false;
    }
  }

  /**
   * Update translateCss to fit screen
   */
  public fitScreen() {
    const ww: number = window.innerWidth;
    const wh: number = window.innerHeight;
    const designW: number = 428;
    const designH: number = 926;
    const ratioH: number = Math.min(1, wh / designH);
    console.log(ww);
    console.log(wh);
    console.log(ratioH);
    const yOffset: number = -55;  // This is the original translateX with 15px of nudge
    this.translateY = ratioH === 1 ? -40 : -(designH - wh + yOffset);
    console.log(this.translateY);
    this.translateX = ww >= designW ? 0 : ((ww - designW) / 2);
    console.log(this.translateX);
    this.scale = ratioH;
    this.translateCss = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
    console.log(this.translateCss);
  }

  public roundNumber(num: number) {
    //return num.toFixed(2);
    //return Math.round((num + Number.EPSILON) * 100) / 100
  }

  @HostListener("window:resize", ["$event"])
  onResize($event: any) {
    this.fitScreen();
  }

}
